/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_V2_Next_FoldersInputs */

const en_home_v2_next_folders = /** @type {(inputs: Home_V2_Next_FoldersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next folders`)
};

const es_home_v2_next_folders = /** @type {(inputs: Home_V2_Next_FoldersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carpetas siguientes`)
};

/**
* | output |
* | --- |
* | "Next folders" |
*
* @param {Home_V2_Next_FoldersInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const home_v2_next_folders = /** @type {((inputs?: Home_V2_Next_FoldersInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_V2_Next_FoldersInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_v2_next_folders(inputs)
	return en_home_v2_next_folders(inputs)
});